import { createModule } from 'vuex-toast';

import auth from './auth';
import dashboard from './dashboard';
import user from './user';
import profile from './profile';
import configuration from './configuration';
import evaluation from './evaluation';
import stock from './stock';
import ranking from './ranking';
import home from './home';
import market from './market';
import payment from './payment';
import common from './common';
import portfolio from './portfolio';
import notification from './notification';
import industry from './industry';
import templates from './templates';

export default {
  auth,
  user,
  dashboard,
  profile,
  configuration,
  evaluation,
  stock,
  ranking,
  portfolio,
  notification,
  home,
  market,
  payment,
  industry,
  templates,
  common,
  toast: createModule({ dismissInterval: 8000 }),
};
